import React from "react"
import "../../assets/scss/styles.scss"
import { ContractorCard } from "./contractor-card"


export const ContractorList = ({
    setShowModal, 
    setRequestedContractor, 
    setOverlay, 
    contractors,
    user
}) => {
    return (
        <div className={ `contractor-list-container` }>
            {
                contractors?.map((contractor) =>
                <ContractorCard
                    key={contractor.Id}
                    contractor={contractor}
                    setShowModal={setShowModal}
                    setRequestedContractor={setRequestedContractor}
                    setOverlay={setOverlay}
                    user={user}
                />)
             }
        </div>
    )
}
